export default __webpack_public_path__ + "static/media/img-23.9df3b3be.jpg";